<template>
    <div>
        <div class="modal fade" id="animationModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Animation Editor</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <form>

                            <div class="row mb-3">
                                <label for="formatOptions" class="col-sm-3 col-form-label">Pattern</label>
                                <div class="col-sm-9">
                                    <select id="formatOptions" class="form-select" v-model="component.animation.value">
                                        <option value="fadeInDown">fade down</option>
                                        <option value="lightSpeedInLeft">speed in left</option>
                                        <option value="bounce">bounce</option>
                                        <option value="rubberBand">rubberBand</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label class="col-sm-3 col-form-label">Loop</label>
                                <div class="col-sm-9">

                                    <i v-if="component.animation.loop" @click="component.animation.loop = false"
                                       class="fas fa-toggle-on text-success mt-3 pointer"></i>
                                    <i v-else @click="component.animation.loop = true"
                                       class="fas fa-toggle-off text-secondary mt-3 pointer"></i>

                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="animationDelay" class="col-sm-3 col-form-label">Delay</label>
                                <div class="col-sm-9">
                                    <input id="animationDelay" class="form-control" v-model="component.animation.delay">
                                    <small id="passwordHelpBlock" class="form-text text-muted">
                                        Number of seconds between animation
                                    </small>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="defaultValue" class="col-sm-3 col-form-label">Value</label>
                                <div class="col-sm-9">
                                    <input id="defaultValue" class="form-control" v-model="component.value" disabled>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label class="col-sm-3 col-form-label">
                                    Values <i class="fad fa-plus-circle pointer" @click="onAddClick"></i>
                                </label>

                                <div class="col-sm-9">
                                    <div class="row" v-for="(child, index) in component.animation.children">
                                        <div class="col-12 mb-1">
                                            <input type="text" class="value-input" placeholder="value" v-model="child.value">
                                            <i class="fad fa-times-circle pointer" @click="onRemoveClick(index)"></i>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>

                        <!-- preview -->
                        <animation-container :component="component" :preview-background="previewBackground"></animation-container>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import AnimationContainer from "../views/renderers/AnimationContainer.vue";
    import OnOffControl from "./OnOffControl.vue";
    export default {
        components: {OnOffControl, AnimationContainer},
        props: {
            yesEvent: Function,
            component: Object
        },
        data() {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        computed: {
            previewBackground() {
                return this.component.style.color === 'light' ? 'bg-dark' : 'bg-light'
            }
        },
        mounted() {
            this.modalElement = document.getElementById('animationModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                // hide the modal
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            },
            onAddClick() {
                let nextIndex = this.component.animation.children.length
                this.component.animation.children.push({value: '', index: nextIndex })
            }
            ,
            onRemoveClick(index) {
                this.component.animation.children.splice(index, 1)
            }
        }
    }
</script>
